module.exports = "<section class=\"\">\r\n  <app-shouter></app-shouter>\r\n\r\n  <app-displayer></app-displayer>\r\n\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main